import { AUTH_TUTOR, INITIALIZE } from 'actions'

/**
 * @type GenderState = Gender[]
 */
const initialState = []

const genderReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_TUTOR:
        case INITIALIZE:
            return action.payload.genders || []
        default:
            return state
    }
}

export default genderReducer
